module.exports = __webpack_public_path__ + "img/icon_box_outlined.b9cc01b4.svg";